module.exports = __webpack_public_path__ + "media/images/file-icons/128/005-database-b2585d7efbf9495a3e12be4c8bd7ae3d.png";